// /src/Callback.js
import React, { useEffect } from "react";
import { AL } from "./al";

const Callback = () => {
  useEffect(() => {
    AL.login_redirect_cb = (response, error) => {
      if (response) {
        window.location.href = "/"; // redirect to main app
      } else if (error) {
        console.error("Login error:", error);
        AL.loginRedirect({ scopes: ["openid", "profile", "email"] });
      }
    };
  }, []);

  return <div>Processing login...</div>;
};

export default Callback;
